<n-slide-window *ngIf="pageReady" [visible]="windowVisible"[width]="SWITCH.IS_SIMPLE_MODE ? '6.08rem' : '7rem'" (onHide)="close()">
    <n-header>
        <h1>{{i18n.title.modifyShare}}</h1>
        <n-help-link key="nfsModify" *ngIf = "!SWITCH.IS_SIMPLE_MODE"></n-help-link>
        <n-help-link key="simplifynfsManage" *ngIf="SWITCH.IS_SIMPLE_MODE"></n-help-link>
    </n-header>

    <form [errorMessage]="errorMessage" [formGroup]="vm" [simpleMode]="SWITCH.IS_SIMPLE_MODE"
        [ngClass]="{ 'form-width-simple': SWITCH.IS_SIMPLE_MODE, 'common-form': !SWITCH.IS_SIMPLE_MODE }">
        <!-- 共享名称，只展示 -->
        <n-form-item [required]="false" [label]="i18n.label.share_name">
            <div id="modify-nfs-share-share_path" class="n-form-item-text text-wrap">{{data.NAME || this.UNPLACEHOLDER}}</div>
        </n-form-item>
            <!-- 共享路径，只展示 -->
            <n-form-item [required]="false" [label]="i18n.label.share_path">
                <div id="modify-nfs-share-share_path" class="n-form-item-text text-wrap">{{data.SHAREPATH || this.UNPLACEHOLDER}}</div>
            </n-form-item>
            <!-- 描述 -->
            <n-form-item [label]="i18n.label.description">
                <textarea id="modify-nfs-share-description"
                    nTextarea
                    formControlName="DESCRIPTION"
                    [placeholder]="errorMessage.DESCRIPTION.rangeByteLength">
                </textarea>
            </n-form-item>
            <!-- 字符集 -->
            <n-form-item [label]="i18n.label.charEncoding"
                [helpContent]="i18n.label.nfsCharCodeTip">
                <n-select id="modify-nfs-share-charEncoding"
                    [options]="charEncodingOpts"
                    formControlName="CHARACTERENCODING">
                </n-select>
            </n-form-item>
            <!-- 显示Snapshot -->
            <n-form-item [label]="i18n.label.showSnapShotLab"
                [helpContent]="i18n.label.showSnapShotTip"
                *ngIf="!ProductConfig.isHideNfsSnapShot">
                <n-checkbox id="modify-nfs-share-enableShowSnapshot"
                    [label]="i18n.label.enable"
                    formControlName="ENABLESHOWSNAPSHOT">
                </n-checkbox>
            </n-form-item>
    </form>

    <n-footer>
        <button id="modify-nfs-share-ok-btn" nButton theme="primary" [label]="i18n.btn.okBtn" (click)="onOk()">
        </button>
        <button id="modify-nfs-share-cancel-btn" nButton [label]="i18n.btn.cancelBtn" (click)="hide()">
        </button>
    </n-footer>
</n-slide-window>
